import { z } from "zod";

export const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/** Validates slug when provided; empty string is allowed (server auto-generates). */
export const optionalSlugSchema = z
  .string()
  .refine((val) => val.trim() === "" || slugRegex.test(val.trim()), {
    message: "Slug inválido. Use apenas letras minúsculas, números e hífens.",
  });

/** Omit slug from GraphQL input when blank so the server parameterizes from name. */
export function slugInputValue(slug: string): string | undefined {
  const trimmed = slug.trim();
  return trimmed === "" ? undefined : trimmed;
}
